<form class="app-grid" #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-6">
            <mat-label>{{ 'forms.field-groups.groupName' | translate }}</mat-label>
            <input
                type="text"
                name="dataFieldGroupName"
                [(ngModel)]="fieldGroup.name"
                [required]="areInputsRequired"
                [disabled]="areInputsDisabled"
                matInput
                #dataFieldGroupName="ngModel"
            />
            <mat-error *ngIf="dataFieldGroupName.invalid">{{ dataFieldGroupName.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-6">
            <mat-label appRemoveAriaOwns>{{ 'forms.field-groups.location' | translate }}</mat-label>
            <mat-select
                placeholder="{{ 'forms.field-groups.pleaseSelectAnOption' | translate }}"
                #groupComponent="ngModel"
                name="groupComponent"
                [(ngModel)]="fieldGroup.component"
                [required]="areInputsRequired"
                [disabled]="areInputsDisabled"
            >
                <mat-option value="personal">{{ 'forms.field-groups.personal' | translate }}</mat-option>
                <mat-option value="job_and_pay">{{ 'forms.field-groups.jobAndPay' | translate }}</mat-option>
            </mat-select>
            <mat-error *ngIf="groupComponent.invalid">{{ groupComponent.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
